import React, { useEffect, useState } from "react";
import Modal from "react-bootstrap/Modal";
import TableData from "./TableData";
import Table from "react-bootstrap/Table";
import moment from "moment/moment";

import {
  base_url,
  STATUS_NEW,
  STATUS_IN_PROGRESS,
  STATUS_APPROVED,
  STATUS_REJECTED,
  STATUS_PROCESSED,
  LOAN_CURRENCY_TYPE_BHD,
  LOAN_CURRENCY_TYPE_USD,
  SERVICE_REQUEST_NEW_LOAN,
  SERVICE_REQUEST_EXTEND_TENURE,
  SERVICE_REQUEST_PRE_CLOSURE,
  SERVICE_REQUEST_PARTIAL_PRE_PAYMENT,
  LOAN_REPAYMENT_BY_BUSINESS,
  STATUS_CLOSED,
} from "./../utilities";
const AdminEachLoanBreakUp = (props) => {
  let EachLoanData =
    props.singleloandata !== "" &&
    props.singleloandata !== undefined &&
    props.singleloandata !== null
      ? props.singleloandata
      : "No Data";
  const [activeTab, setActiveTab] = useState("home-tab");
  const [sortOrder, setSortOrder] = useState({ column: null, direction: null });
  const handlEachLoanData =
    EachLoanData.payment_schedules !== "" ||
    EachLoanData.payment_schedules !== undefined ||
    EachLoanData.payment_schedules !== null
      ? EachLoanData.payment_schedules
      : [];

  const [paymentSchedules, setPaymentSchedules] = useState();

  useEffect(() => {
    if (
      EachLoanData.payment_schedules !== "" ||
      EachLoanData.payment_schedules !== undefined ||
      EachLoanData.payment_schedules !== null
    ) {
      setPaymentSchedules(EachLoanData.payment_schedules);
    }
  }, [EachLoanData]);

  const handleClose = () => {
    props.onHide();
    setActiveTab("home-tab");
  };

  const columns = [
    {
      title: "Investment Payment",
      field: "tenure_amount",
      currency: "admin_request_loan_currency",
    },
    { title: "Tenure Date", field: "tenure_date" },
    {
      title: "Amount Repaid",
      field: "paid_amount",
      currency: "admin_request_loan_currency",
    },
  ];
  const handleSort = (column) => {
    let direction = "asc";
    if (sortOrder.column === column && sortOrder.direction === "asc") {
      direction = "desc";
    }
    setSortOrder({ column, direction });
    const sortedData = [...paymentSchedules].sort((a, b) => {
      const columnA =
        column === "paid_amount" ? parseInt(a[column]) : a[column];
      const columnB =
        column === "paid_amount" ? parseInt(b[column]) : b[column];
      if (typeof columnA === "string" && typeof columnB === "string") {
        return direction === "asc"
          ? columnA.localeCompare(columnB)
          : columnB.localeCompare(columnA);
      } else if (typeof columnA === "number" && typeof columnB === "number") {
        return direction === "asc" ? columnA - columnB : columnB - columnA;
      } else {
        return 0;
      }
    });
    setPaymentSchedules(sortedData);
  };

  let loanhistorydata = EachLoanData.loan_history;
  let loan_history_array = [];
  loanhistorydata?.map((each_history_record) => {
    //NEW LOAN REQUEST LIST
    if (
      each_history_record.status == STATUS_NEW &&
      each_history_record.service_type_code == SERVICE_REQUEST_NEW_LOAN
    ) {
      let message = "Business requested loan";
      let created_date_time = each_history_record.created_date_time;
      let message_object = {
        message: message,
        created_date_time: created_date_time,
      };
      loan_history_array.push(message_object);
    }
    if (
      !each_history_record.is_investor_interested &&
      !each_history_record.is_admin_sent_terms_to_business
    ) {
      if (
        each_history_record.status == STATUS_IN_PROGRESS &&
        each_history_record.service_type_code == SERVICE_REQUEST_NEW_LOAN
      ) {
        let message =
          "Admin filled the profit percentage and sent to investors";
        let created_date_time = each_history_record.created_date_time;
        let message_object = {
          message: message,
          created_date_time: created_date_time,
        };
        loan_history_array.push(message_object);
      }
    }
    if (
      each_history_record.status == STATUS_REJECTED &&
      each_history_record.service_type_code == SERVICE_REQUEST_NEW_LOAN
    ) {
      let message = "Admin rejected the new loan request";
      let created_date_time = each_history_record.created_date_time;
      let message_object = {
        message: message,
        created_date_time: created_date_time,
      };
      loan_history_array.push(message_object);
    }
    if (
      each_history_record.status == STATUS_IN_PROGRESS &&
      each_history_record.is_investor_interested === 1 &&
      each_history_record.service_type_code == SERVICE_REQUEST_NEW_LOAN
    ) {
      let message = "Investor has shown interest on this loan";
      let created_date_time = each_history_record.created_date_time;
      let message_object = {
        message: message,
        created_date_time: created_date_time,
      };
      loan_history_array.push(message_object);
    }
    if (
      each_history_record.status == STATUS_IN_PROGRESS &&
      each_history_record.is_admin_sent_terms_to_business === 1 &&
      each_history_record.service_type_code == SERVICE_REQUEST_NEW_LOAN
    ) {
      let message = "Admin sent loan terms and awaiting for business response";
      let created_date_time = each_history_record.created_date_time;
      let message_object = {
        message: message,
        created_date_time: created_date_time,
      };
      loan_history_array.push(message_object);
    }

    if (
      each_history_record.status == STATUS_APPROVED &&
      each_history_record.service_type_code == SERVICE_REQUEST_NEW_LOAN
    ) {
      let message = "Business agreed the new loan request terms";
      let created_date_time = each_history_record.created_date_time;
      let message_object = {
        message: message,
        created_date_time: created_date_time,
      };
      loan_history_array.push(message_object);
    }

    if (
      each_history_record.status == STATUS_PROCESSED &&
      each_history_record.service_type_code == SERVICE_REQUEST_NEW_LOAN
    ) {
      let message = (
        <div className="style_loan_txt">
          Admin paid the requested loan amount{" "}
          <span
            style={{ color: "black", marginTop: "2px" }}
            className="ps-1 pe-1 fw-bold"
          >
            {each_history_record.paid_currency +
              " " +
              Number(each_history_record.paid_amount).toLocaleString()}
          </span>{" "}
          to business on{" "}
          <span
            style={{ color: "black", marginTop: "2px" }}
            className="ps-1 pe-1 fw-bold"
          >
            {moment(each_history_record.paid_date).format("DD MMM YYYY")}
          </span>
        </div>
      );
      let created_date_time = each_history_record.created_date_time;
      let message_object = {
        message: message,
        created_date_time: created_date_time,
      };
      loan_history_array.push(message_object);
    }
    if (
      each_history_record.status == LOAN_REPAYMENT_BY_BUSINESS &&
      each_history_record.service_type_code == SERVICE_REQUEST_NEW_LOAN
    ) {
      let message = (
        <div className="">
          Business repaid for the month of{" "}
          <span style={{ color: "black" }} className="fw-bold">
            {moment(each_history_record.tenure_date).format("MMMM")}
          </span>
          , loan tenure amount{" "}
          <span style={{ color: "black" }} className="fw-bold">
            {each_history_record.paid_currency +
              " " +
              Number(each_history_record.paid_amount).toLocaleString()}
          </span>{" "}
          to admin on{" "}
          <span style={{ color: "black" }} className=" fw-bold">
            {moment(each_history_record.paid_date).format("DD MMM YYYY")}
          </span>
        </div>
      );
      let created_date_time = each_history_record.created_date_time;
      let message_object = {
        message: message,
        created_date_time: created_date_time,
      };
      loan_history_array.push(message_object);
    }

    if (
      each_history_record.status == STATUS_NEW &&
      each_history_record.service_type_code == SERVICE_REQUEST_EXTEND_TENURE
    ) {
      let message = "Business requested to extend loan tenure";
      let created_date_time = each_history_record.created_date_time;
      let message_object = {
        message: message,
        created_date_time: created_date_time,
      };
      loan_history_array.push(message_object);
    }
    if (
      each_history_record.status == STATUS_APPROVED &&
      each_history_record.service_type_code == SERVICE_REQUEST_EXTEND_TENURE
    ) {
      let message = "Admin approved extend tenure request";
      let created_date_time = each_history_record.created_date_time;
      let message_object = {
        message: message,
        created_date_time: created_date_time,
      };
      loan_history_array.push(message_object);
    }

    if (
      each_history_record.status == STATUS_REJECTED &&
      each_history_record.service_type_code == SERVICE_REQUEST_EXTEND_TENURE
    ) {
      let message = "Admin rejected the extend tenure request";
      let created_date_time = each_history_record.created_date_time;
      let message_object = {
        message: message,
        created_date_time: created_date_time,
      };
      loan_history_array.push(message_object);
    }

    if (
      each_history_record.status == STATUS_NEW &&
      each_history_record.service_type_code == SERVICE_REQUEST_PRE_CLOSURE
    ) {
      let message = "Business requested for pre closure of a loan";
      let created_date_time = each_history_record.created_date_time;
      let message_object = {
        message: message,
        created_date_time: created_date_time,
      };
      loan_history_array.push(message_object);
    }
    if (
      each_history_record.status == STATUS_APPROVED &&
      each_history_record.service_type_code == SERVICE_REQUEST_PRE_CLOSURE
    ) {
      let message = "Admin approved pre closure request";
      let created_date_time = each_history_record.created_date_time;
      let message_object = {
        message: message,
        created_date_time: created_date_time,
      };
      loan_history_array.push(message_object);
    }
    if (
      each_history_record.status == STATUS_REJECTED &&
      each_history_record.service_type_code == SERVICE_REQUEST_PRE_CLOSURE
    ) {
      let message = "Admin rejected pre closure request";
      let created_date_time = each_history_record.created_date_time;
      let message_object = {
        message: message,
        created_date_time: created_date_time,
      };
      loan_history_array.push(message_object);
    }
    if (
      each_history_record.status == STATUS_NEW &&
      each_history_record.service_type_code ==
        SERVICE_REQUEST_PARTIAL_PRE_PAYMENT
    ) {
      let message = "Business requested for partial pre-payment of a loan";
      let created_date_time = each_history_record.created_date_time;
      let message_object = {
        message: message,
        created_date_time: created_date_time,
      };
      loan_history_array.push(message_object);
    }
    if (
      each_history_record.status == STATUS_APPROVED &&
      each_history_record.service_type_code ==
        SERVICE_REQUEST_PARTIAL_PRE_PAYMENT
    ) {
      let message = "Admin approved partial pre-payment request";
      let created_date_time = each_history_record.created_date_time;
      let message_object = {
        message: message,
        created_date_time: created_date_time,
      };
      loan_history_array.push(message_object);
    }
    if (
      each_history_record.status == STATUS_REJECTED &&
      each_history_record.service_type_code ==
        SERVICE_REQUEST_PARTIAL_PRE_PAYMENT
    ) {
      let message = "Admin rejected partial pre-payment request";
      let created_date_time = each_history_record.created_date_time;
      let message_object = {
        message: message,
        created_date_time: created_date_time,
      };
      loan_history_array.push(message_object);
    }
    if (
      each_history_record.status == STATUS_CLOSED &&
      each_history_record.service_type_code == SERVICE_REQUEST_NEW_LOAN
    ) {
      let message = "Business repaid the loan successfully";
      let created_date_time = each_history_record.created_date_time;
      let message_object = {
        message: message,
        created_date_time: created_date_time,
      };
      loan_history_array.push(message_object);
    }
  });

  return (
    <Modal
      {...props}
      size="xl"
      aria-labelledby="contained-modal-title-vcenter"
      centered
      backdrop="static"
      keyboard={false}
      className="admin_eachloan_modal_main"
    >
      <Modal.Header className="Admin_eachL_popup">
        <div className=" p-0 ps-5 mt-3">
          <div className="row ">
            <h6 className="mb-0 sesame-color mb-3">
              Loan Reference No. {EachLoanData.loan_reference_number}
            </h6>
            <div className="col-lg-1 me-3">
              <div className="mb-3">
                <p className="text_st ">Loan</p>
                <span className="bolder_text ">
                  {EachLoanData.serial_number}
                </span>
              </div>
            </div>

            <div className="col-lg-2 me-2 ps-3">
              <div className="mb-3">
                <p className="text_st ">Total Loan</p>
                <span className="bolder_text ">
                  {EachLoanData.admin_request_loan_amount === undefined ||
                  EachLoanData.admin_request_loan_amount === ""
                    ? "-"
                    : EachLoanData.admin_request_loan_currency ===
                      LOAN_CURRENCY_TYPE_USD
                    ? "$"
                    : "BHD"}{" "}
                  {Number(
                    EachLoanData.admin_request_loan_amount
                  ).toLocaleString()}
                </span>
              </div>
            </div>

            <div className="col-lg-2 me-2 ps-3">
              <div className="mb-3">
                <p className="text_st ">Monthly Rate</p>
                <span className="bolder_text ">
                  {EachLoanData.bennefin_roi === "" ||
                  EachLoanData.bennefin_roi === undefined ||
                  EachLoanData.bennefin_roi === null
                    ? "-"
                    : EachLoanData.bennefin_roi + "%"}
                </span>
              </div>
            </div>

            <div className="col me-2 ps-3">
              <div className="mb-3">
                <p className="text_st ">Tenure</p>
                <span className="bolder_text ">
                  {EachLoanData.admin_request_loan_tenure !== undefined ||
                  EachLoanData.admin_request_loan_tenure !== ""
                    ? EachLoanData.admin_request_loan_tenure === 1
                      ? EachLoanData.admin_request_loan_tenure + " Month"
                      : EachLoanData.admin_request_loan_tenure + " Months"
                    : "-"}
                </span>
              </div>
            </div>

            <div className="col-lg-3 me-2 ps-3">
              <div className="mb-3">
                <p className="text_st ">Principal Payment Frequency</p>
                <span className="bolder_text ">
                  {EachLoanData.principal_frequency === "" ||
                  EachLoanData.principal_frequency === undefined ||
                  EachLoanData.principal_frequency === null
                    ? "-"
                    : EachLoanData.principal_frequency}
                </span>
              </div>
            </div>

            <div className="col ps-2 ms-2">
              <div className="mb-3">
                <p className="text_st ">Status</p>
                <span className="bolder_text ">
                  {EachLoanData.status === undefined ||
                  EachLoanData.status === ""
                    ? "-"
                    : EachLoanData.status}
                </span>
              </div>
            </div>
          </div>
        </div>
        <div>
          <button
            onClick={handleClose}
            closeButton
            type="button"
            className="btn-close col-lg-1 ms-0 me-3"
            aria-label="Close"
          ></button>
        </div>
      </Modal.Header>
      <Modal.Body className="perticlr_modal_body px-3">
        <div className="row p-5 pt-0 gap-5">
          <div className="col-lg-6 me-5">
            <div className="row bg-white mt-3">
              <div className="col admin_each_ln_pop">
                <ul
                  className="nav nav-tabs d-flex gap-3"
                  id="myTab"
                  role="tablist"
                >
                  <li className="nav-item-aelb" role="presentation">
                    <button
                      className={`nav-link ${
                        activeTab === "home-tab" ? "active" : ""
                      } p-1`}
                      id="home-tab"
                      data-bs-toggle="tab"
                      data-bs-target="#home-tab-pane"
                      type="button"
                      role="tab"
                      aria-controls="home-tab-pane"
                      aria-selected="true"
                      onClick={() => setActiveTab("home-tab")}
                    >
                      <h6 className="">Schedule Of Return Payments</h6>
                      {activeTab === "home-tab" && (
                        <img
                          style={{ marginTop: "-43px" }}
                          src="./images/polygondown.svg"
                          alt=""
                        />
                      )}
                    </button>
                  </li>
                  <li className="nav-item-aelb" role="presentation">
                    <button
                      className={`nav-link ${
                        activeTab === "profile-tab" ? "active" : ""
                      } p-1`}
                      id="profile-tab"
                      data-bs-toggle="tab"
                      data-bs-target="#profile-tab-pane"
                      type="button"
                      role="tab"
                      aria-controls="profile-tab-pane"
                      aria-selected="false"
                      onClick={() => setActiveTab("profile-tab")}
                    >
                      <h6 className="">Loan History</h6>
                      {activeTab === "profile-tab" && (
                        <img
                          style={{ marginTop: "-43px" }}
                          src="./images/polygondown.svg"
                          alt=""
                        />
                      )}
                    </button>
                  </li>
                </ul>
              </div>
            </div>
            <div className="tab-content" id="myTabContent">
              <div
                className="tab-pane fade show active  "
                id="home-tab-pane"
                role="tabpanel"
                aria-labelledby="home-tab"
                tabIndex="0"
              >
                <div className="newinvinteresttable-style">
                  <Table striped className="">
                    <TableData
                      handleSort={handleSort}
                      columns={columns}
                      data={paymentSchedules}
                    />
                  </Table>
                </div>
              </div>
              <div
                className="tab-pane fade loan_history_tab admin_each_history"
                id="profile-tab-pane"
                role="tabpanel"
                aria-labelledby="profile-tab"
                tabIndex="0"
              >
                <div className="">
                  {loan_history_array.map((details) => {
                    return (
                      <div key={details.message} className="row pt-0">
                        <div className="style_loan">
                          <img
                            className="me-2"
                            src="./images/circle.svg"
                            alt=""
                            srcSet=""
                            height={16}
                            width={16}
                          />
                          {moment(details.created_date_time).format(
                            "ddd , D MMM YYYY"
                          )}
                        </div>
                        <div className="style_loan_txt mb-4 ms-4 pe-5">
                          {details.message}
                        </div>
                      </div>
                    );
                  })}
                </div>
              </div>
            </div>
          </div>

          <div className="col mt-4">
            <h6>Service Requests</h6>
            <hr />
            <p>1.Tenure Extension Request</p>
            {EachLoanData.extend_tenure === "" ||
            EachLoanData.extend_tenure === 0 ||
            EachLoanData.extend_tenure === undefined ||
            EachLoanData.extend_tenure === null
              ? "-"
              : EachLoanData.extend_tenure == 1
              ? EachLoanData.extend_tenure + " Month"
              : EachLoanData.extend_tenure + " Months"}
            <hr />
            <p>2.Preclosure Request Date</p>
            {EachLoanData.preclosure_date === "" ||
            EachLoanData.preclosure_date === 0 ||
            EachLoanData.preclosure_date === undefined ||
            EachLoanData.preclosure_date === null
              ? "-"
              :moment(EachLoanData.preclosure_date).format("DD MMM YYYY") 
    }
            <hr />
            <p>3.Partial Prepayment Request Date</p>
            {EachLoanData.partial_prepayment_date === "" ||
            EachLoanData.partial_prepayment_date === 0 ||
            EachLoanData.partial_prepayment_date === undefined ||
            EachLoanData.partial_prepayment_date === null
              ? "-"
              :moment(EachLoanData.partial_prepayment_date).format("DD MMM YYYY") }
            <p className="mt-1">Partial Prepayment Request Amount</p>
            {EachLoanData.partial_prepayment_amount === "" ||
            EachLoanData.partial_prepayment_amount === undefined ||
            EachLoanData.partial_prepayment_amount === null
              ? "-"
              :EachLoanData.admin_request_loan_currency=="BHD"?"BHD " + EachLoanData.partial_prepayment_amount:"$ " + EachLoanData.partial_prepayment_amount}
  
          </div>
        </div>
      </Modal.Body>
      <Modal.Footer className="">
        <div className="">
          <button
            className="graytwo_btn btn mx-2 px-3 py-2"
            variant="secondary"
            onClick={handleClose}
          >
            Close
          </button>
        </div>
      </Modal.Footer>
    </Modal>
  );
};

export default AdminEachLoanBreakUp;
